import { useState, useMemo, Fragment } from "react";

import ComponentLightCodeModal from "../Component/ComponentLightCodeModal";

import { getLabel } from "../../tools/Dictionary";
import { FaRegCircle } from "react-icons/fa";
import { MdOutlineLightMode, MdOutlineMotionPhotosOff } from "react-icons/md";
import { LiaHandPointer } from "react-icons/lia";


const ConditionDesignerLightCode = (props) =>
{

  //Props
  //const IsDesktop = props.IsDesktop;
  const Access = props.Access;
  const ReadOnly = props.ReadOnly;
  const Value = props.Value;
  const Data = props.Data;
  const OnChangeData = props.OnChangeData;



  //Init
  const initValue = useMemo(() =>
  {
    let initForm = '';

    for (let i = 0; i < Data.lightAmount; i++)
    {
      initForm += '_';
    }

    return initForm;
  }, [Data.lightAmount]);

  //State
  const [form, setForm] = useState(Value || initValue);
  const [modal, setModal] = useState({
    display: false,
    index: -1,
    value: undefined
  });

  const onChangeLight = (_value) => {
    let currentForm = form.split('');

    currentForm[modal.index] = _value;

    setForm(currentForm.join(''));
    OnChangeData(currentForm.join(''), "");
    setModal({ display: false, index: -1, value: "" });
  }

  const displayIcon = (_value, _index) =>
  {


    if (_value == "_" && form.indexOf("_") == _index)
      return (
        <div className="component_light_item component_light_item_clicking" 
          key={_index} onClick={() => setModal({ display: true, index: _index, value: _value })} title={getLabel("ConditionDesigner", "Edit the error code")}>
          <LiaHandPointer />
        </div>
      );

    if (_value == "X")
      return (
        <div className="component_light_item"
          key={_index}
          onClick={() => setModal({ display: true, index: _index, value: _value })} style={{ color: "#b30000" }}
          title={getLabel("ComponentEntity", "Light off")}
        >
          <MdOutlineMotionPhotosOff />
        </div>
      );

    if (_value == "O")
      return (
        <div className="component_light_item"
          key={_index}
          onClick={() => setModal({ display: true, index: _index, value: _value })} style={{ color: "#008000" }}
          title={getLabel("ComponentEntity", "Light on")}
        >
          <FaRegCircle />
        </div>
      );

    if (_value == "F")
      return (
        <div className="component_light_item"
          key={_index}
          onClick={() => setModal({ display: true, index: _index, value: _value })}
          style={{ color: "#e68a00" }}
          title={getLabel("ComponentEntity", "Flashing light")}
        >
          <MdOutlineLightMode />
        </div>
      );

    return <div className="component_light_item" onClick={() => setModal({ display: true, index: _index, value: _value })} title={getLabel("ConditionDesigner", "Edit the error code")}  />;

  };

  let listForm = form.split('');

  //onClick={() => OnClickUserVariable(GroupIndex, ConditionIndex, _property)}

  return (
    <div className="conditiondesigner_item_display_cont" >
      {Access.canWrite && !ReadOnly && modal.display &&
        <ComponentLightCodeModal
          Value={modal.value}
          OnChangeLight={onChangeLight}
          OnCloseModal={() => setModal({ display: false, index: -1, value: "" })}
        />
      }
      <div className="component_light_cont" >
        {listForm.map((f, index) => (
          <Fragment key={index} >
            {displayIcon(f, index)}
          </Fragment>
        ))}
      </div>
    </div>
  );

};

export default ConditionDesignerLightCode